import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { typography } from '@resiliatech/birdsong'

export const EditChartDataContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 300px;
`
export const DateString = styled(Typography)`
  ${typography.baseline.regularSans};
`

export const PaginationContainer = styled(Box)`
  display: flex;
  justify-content: center;
  padding-top: 8px;
`
